import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './styles/tokens.css';
import './styles/base.css';
import './styles/chat.css';
import './styles/board.css';
import './styles/activity.css';
import './styles/nav.css';

import App from './app/App';
import DevWorkspace from './devtools/DevWorkspace';
import './styles/devtools.css';
import ErrorBoundary from './app/ErrorBoundary';
import { registerOfflineWorker } from './offline/register';
import { applyTheme, useSession } from './store/sessionStore';

// Before the first paint, or a pinned dark theme flashes white.
applyTheme(useSession.getState().theme);

// The offline shell (#43): a built page whose CSP allows `worker-src 'self'`;
// otherwise nothing is attempted and the page works as it always did.
window.addEventListener('load', () => {
  const policy = document.querySelector('meta[http-equiv="Content-Security-Policy"]')?.getAttribute('content') ?? '';
  void registerOfflineWorker(
    'serviceWorker' in navigator ? navigator.serviceWorker : undefined,
    import.meta.env.PROD,
    policy,
    import.meta.env.VITE_PH_OFFLINE_SW !== 'off',
    'caches' in window ? caches : undefined,
  );
});

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <ErrorBoundary
        label="app"
        fallback={
          <div className="curtain">
            <h2 className="curtain__title">Что-то сломалось</h2>
            <p className="curtain__text">
              Перезагрузите страницу — разговор хранится на сервере и не потеряется.
            </p>
          </div>
        }
      >
        <DevWorkspace><App /></DevWorkspace>
      </ErrorBoundary>
    </StrictMode>,
  );
}
